module.exports = __webpack_public_path__ + "img/eshop-4.1539a988.png";